import React from 'react';
import FixedOpsScoreboard from './FixedOpsScoreboard';

export default function FixedOpsScoreboardPage({ user, managedOwner }) {
  return <FixedOpsScoreboard user={user} managedOwner={managedOwner} />;
}
